export default __webpack_public_path__ + "static/media/icon-satisfaction.d0171543.webp";